module.exports = __webpack_public_path__ + "img/icon_alert.1442fcf8.svg";